<template>
  <div class="main">
    <Header 
      :show="true"
      title="货车列表"
      left="prepage" 
      right="create" 
      :click-left="handleClickLeft" 
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh;">
      <van-notice-bar
        wrapable
        :scrollable="false"
        left-icon="info-o"
        text="管理货车信息，包含商砼货车及罐装货车"
      />
      <div v-if="checkPermission([177])" style="padding: 20px 30px;">
        <van-button type="primary" block @click="handleClickUnbindAll">一键解绑</van-button>
      </div>
      <el-table
        ref="table"
        :data="table.data"
        :row-key="handleRowKey"
        :expand-row-keys="expandRowKeys"
        :row-class-name="handleRowClassName"
        :cell-style="handleCellStyle"
        @row-click="handleTableRowClick"
      >
        <el-table-column type="expand" width="30px">
          <template slot-scope="{row}">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="序号">
                <span>{{ row.id }}</span>
              </el-form-item>
              <el-form-item label="车牌号">
                <span>{{ row.plateNumber }}</span>
              </el-form-item>
              <el-form-item label="车辆类型">
                <span>{{ row.type }}</span>
              </el-form-item>
              <el-form-item label="车辆大小">
                <span>{{ row.size }}</span>
              </el-form-item>
              <el-form-item label="皮重">
                <span>{{ row.tareWeight }}吨</span>
              </el-form-item>
              <el-form-item label="装载量">
                <span>{{ row.loadCapacity }}吨</span>
              </el-form-item>
              <el-form-item label="司机">
                <span>{{ row.driver }}</span>
              </el-form-item>
              <el-form-item label="手机号码">
                <span>{{ row.phone }}</span>
              </el-form-item>
              <el-form-item label="说明">
                <span>{{ row.remark }}</span>
              </el-form-item>
              <el-form-item label="状态">
                <el-tag v-if="row.status === '工作'" size="small" plain type="success">{{ row.status }}</el-tag>
                <el-tag v-else-if="row.status === '空闲'" size="small" plain type="warning">{{ row.status }}</el-tag>
                <el-tag v-else size="small" plain type="danger">未知</el-tag>
              </el-form-item>
              <el-form-item label="操作" v-if="checkPermission([173]) || checkPermission([174]) || checkPermission([175]) || checkPermission([176])">
                <el-button v-if="(row.driver === '') && checkPermission([175])" type="success" size="mini" @click="handleClickBindDialog(row)">
                  绑定
                </el-button>
                <el-button v-else-if="checkPermission([176])" type="warning" size="mini" @click="handleClickUnbindOne(row)">
                  解绑
                </el-button>
                <el-button v-if="checkPermission([173])" type="primary" size="mini" @click="handleClickUpdate(row)">
                  编辑
                </el-button>
                <el-button v-if="checkPermission([174])" type="danger" size="mini" @click="handleClickDelete(row)">
                  删除
                </el-button>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column label="序号" prop="id" align="center" width="50">
          <template slot-scope="{row}">
            {{ row.id }}
          </template>
        </el-table-column>
        <el-table-column label="车牌号" prop="plateNumber" align="center" show-overflow-tooltip min-width="130">
          <template slot-scope="{row}">
            {{ row.plateNumber }}
          </template>
        </el-table-column>
        <el-table-column label="司机" prop="driver" align="center" show-overflow-tooltip width="80">
          <template slot-scope="{row}">
            {{ row.driver }}
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="status" align="center" show-overflow-tooltip>
          <template slot-scope="{row}">
            <el-tag v-if="row.status === '工作'" size="medium" plain type="success">{{ row.status }}</el-tag>
            <el-tag v-else-if="row.status === '空闲'" size="medium" plain type="warning">{{ row.status }}</el-tag>
            <el-tag v-else size="medium" plain type="danger">未知</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination 
        v-show="table.total>0" 
        :total="table.total" 
        background 
        layout="prev, pager, next"
        :current-page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        :pager-count="table.fullWidth>380?5:3"
        style="margin: .6rem 0; text-align: center;"
        @current-change="handleClickQuery"
      />
      <div style="height: 1rem; background-color: #FFFFFF;" />
      
      <van-dialog
        v-model="dialogVisibleBind" 
        title="绑定货车司机"
        show-cancel-button
        :before-close="handleClickBindConfirm"
      >
        <van-field
          ref="plateNumber"
          v-model="listQuery.plateNumber"
          label="车牌号码"
          placeholder="请输入车牌号码"
          required
          readonly
        />
  <!--      <van-field
          ref="driver"
          v-model="listQuery.driver"
          rows="1"
          autosize
          label="司机姓名"
          placeholder="请输入司机姓名"
          required
        /> -->
        <van-field
          clickable
          name="picker"
          :value="listQuery.driver"
          label="司机姓名"
          placeholder="请选择司机姓名"
          required
          @click="driver.show = true"
          :rules="[{ validator: validCheckName, message: '' }]"
        />
      </van-dialog>
      <van-popup v-model="driver.show" position="bottom">
        <van-picker
          show-toolbar
          :columns="driver.columns"
          @confirm="handleVanPickerConfirmName"
          @cancel="driver.show = false"
        />
      </van-popup>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
  import { Dialog, ImagePreview } from 'vant'
  import { showPhoneAlarm } from '@/global/function.js'
  import { parseTime } from '@/utils'
  import checkPermission from '@/utils/permission'
  import Header from '@/views/components/header/index.vue'
  import Footer from '@/views/components/footer/index.vue'
  import { getList, unbindAll, bindOne, unbindOne, deleteOne  } from '@/api/truck.js'
  import { getList as getStaffList } from '@/api/staff.js'

  export default {
    name: "ServiceSystemTruck",
    components: {
      Header,
      Footer
    },
    inject: ['reload'],
    data() {
      return {
        dialogVisibleBind: false,
        listQuery: {
          limit: 10,
          page: 1,
          driver: '',
          plateNumber: ''
        },
        isLoading: false,
        table: {
          listLoading: false,
          fullWidth: document.documentElement.clientWidth,
          key: 0,
          total: 0,
          data: []
        },
        expandRowKeys: [],
        handleRowKey(row) {
          return row.id
        },
        loading: false,
        driverOptions: [],
        driver: {
          show: false,
          columns: [],
          options: []
        }
      }
    },
    computed: {

    },
    watch: {
      
    },
    beforeCreate() {
      
    },
    created() {
      this.handleClickQuery()
      this.handleGetStaffList()
    },
    beforeMount() {
      
    },
    mounted() {
      
    },
    beforeUpdate() {
      
    },
    updated() {
      
    },
    beforeDestroy() {
      
    },
    destroyed() {
      
    },
    methods: {
      checkPermission,
      handleClickLeft() {
        this.$router.go(-1)
        // console.log('dashboard-left')
      },
      handleClickRight() {
        this.$router.push({ 
          path:'/service/system/truck/create', 
          query: {} ,
        })
      },
      handleTableRowClick(row, column, event) {
        this.$refs.table.toggleRowExpansion(row)
      },
      handleRowClassName({row, rowIndex}) {
        return 'normal-row'
      },
      handleCellStyle({ row, column, rowIndex, columnIndex }) {
        return ''
      },
      onRefresh() {
        setTimeout(() => {
          this.isLoading = false
          showPhoneAlarm(true, 'toast', null, 2000, null, '工程配置', '刷新完成')
        }, 1000)
      },
      handleGetStaffList() {
        const data = {
          page: 1,
          limit: 10000
        }
        getStaffList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            const items = data.data.items
            this.driver.columns = []
            for (let i=0; i<items.length; i++) {
              if (items[i].personType !== 3) {
                this.driver.columns.push(items[i].name)
                this.driver.options.push({
                  id: items[i].id,
                  name: items[i].name
                })
              }
            }
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      validCheckName(val) {
        if (val === '') {
          return false
        } else {
          return true
        }
      },
      handleVanPickerConfirmName(value) {
        this.listQuery.driver = value
        this.driver.show = false
      },
      handleClickQuery() {
        const data = {
          page: this.listQuery.page,
          limit: this.listQuery.limit
        }
        getList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            this.table.total = data.data.total
            const items = data.data.items
            this.table.data = []
            for (let i=0; i<items.length; i++) {
              this.table.data.push({
                id: this.listQuery.limit * (this.listQuery.page - 1) + i + 1,
                serial: items[i].id,
                plateNumber: items[i].plateNumber,
                type: items[i].type,
                size: items[i].truckType,
                tareWeight: items[i].tareWeight,
                loadCapacity: items[i].loadCapacity,
                driver: items[i].driver,
                phone: items[i].phone,
                remark: items[i].remark,
                status: items[i].driver === '' ? '空闲' : '工作'
              })
            }
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      handleClickBindDialog(row) {
        this.listQuery.plateNumber = row.plateNumber
        this.dialogVisibleBind = true
      },
      handleClickBindConfirm(action, done) {
        if (action === 'confirm') {
          if (this.listQuery.driver === '') {
            showPhoneAlarm(true, 'toast', null, 2000, 300, null, '请输入司机姓名')
            done(false)
          } else {
            const data = {
              plateNumber: this.listQuery.plateNumber,
              driver: this.listQuery.driver
            }
            bindOne(data).then(response => {
              const { data } = response
              if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '绑定货车司机', data.message)) {
                this.dialogVisibleBind = false
                this.handleClickQuery()
              }
              done(true)
            }).catch(function(error) {
              console.error(error)
            })
          }
        } else {
          showPhoneAlarm(true, 'toast', 'success', 2000, 200, null, '取消绑定')
          done(true)
        }
      },
      handleClickUnbindAll() {
        Dialog.confirm({
          title: '确认解绑所有商砼货车司机？',
          message: '请在确认货车返厂后操作'
        }).then(() => {
          this.loading = true
          const data = {}
          unbindAll(data).then(response => {
            const { data } = response
            if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '一键解绑', data.message)) {
              this.handleClickQuery()
            }
            this.loading = false
          }).catch(function(error) {
            console.error(error)
          })
        }).catch(() => {
          showPhoneAlarm(true, 'toast', null, 2000, 200, '一键解绑', '取消')
        })
      },
      handleClickUnbindOne(row) {
        Dialog.confirm({
          title: '确认解绑货车司机？',
          message: '货车：' + row.plateNumber,
        }).then(() => {
          this.loading = true
          const data = {
            driver: row.driver,
            plateNumber: row.plateNumber
          }
          unbindOne(data).then(response => {
            const { data } = response
            if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '解绑', data.message)) {
              this.handleClickQuery()
            }
            this.loading = false
          }).catch(function(error) {
            console.error(error)
          })
        }).catch(() => {
          showPhoneAlarm(true, 'toast', null, 2000, 200, '解绑', '取消')
        })
      },
      handleClickUpdate(row) {
        this.$router.push({ path:'/service/system/truck/update', query: row })
      },
      handleClickDelete(row) {
        Dialog.confirm({
          title: '确认删除货车？',
          message: '货车：' + row.plateNumber,
        }).then(() => {
          this.loading = true
          const data = {
            id: row.serial
          }
          deleteOne(data).then(response => {
            const { data } = response
            if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '删除', data.message)) {
              this.loading = false
              this.table.data.splice(this.table.data.indexOf(row), 1)
            }
          }).catch(function(error) {
            console.error(error)
          })
        }).catch(() => {
          showPhoneAlarm(true, 'toast', null, 2000, 200, '删除', '取消')
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  // 系统样式修改
  ::v-deep .el-form-item__label {
    width: 20%;
    text-align: right;
    // margin-right: 20px;
  }
  ::v-deep .el-table__expanded-cell[class*=cell] {
    padding: 20px 10px;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
  }
  ::v-deep .van-cell__title {
    max-width: 30%;
  }
  ::v-deep .van-cell__value {
    max-width: 70%;
  }
  ::v-deep .el-table th>.cell {
    padding-left: 5px;
    padding-right: 5px;
  }
  ::v-deep .el-table td>.cell {
    padding-left: 5px;
    padding-right: 5px;
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  // 自定义样式
  .main {
    height: 100vh;
    font-size: 2vw;
    background-color: #FFFFFF;//#F7F8FA; 
    overflow-x: hidden;
    // overflow-y:hidden;
    overflow-y: auto;
    // display: flex; 
    // justify-content: center; 
    // align-items: center;
  }
</style>
